import React from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarDaysIcon, MagnifyingGlassIcon, BellAlertIcon, LanguageIcon } from '@heroicons/react/24/outline';
import { Container, Reveal, shot } from './primitives';

const CARDS = [
  { id: 'portal', image: 'bento-portal', imageClass: 'start-[7%] top-[11%] w-[118%]' },
  { id: 'chat', image: 'bento-chat', imageClass: 'start-[7%] top-[13%] w-[112%]' }
];

const EXTRAS = [
  { id: 'calendar', icon: CalendarDaysIcon },
  { id: 'search', icon: MagnifyingGlassIcon },
  { id: 'notifications', icon: BellAlertIcon },
  { id: 'languages', icon: LanguageIcon }
];

export default function CollaborationSection() {
  const { t, i18n } = useTranslation();

  return (
    <section
      id="portal"
      className="lp-section scroll-mt-16 bg-gradient-to-b from-white to-sand-50"
      aria-labelledby="portal-title"
    >
      <Container>
        <Reveal className="mx-auto max-w-[760px] text-center">
          <h2 id="portal-title" className="lp-h2">
            {t('landing.collaboration.title')}
          </h2>
          <p className="lp-body mx-auto mt-5 max-w-[560px]">{t('landing.collaboration.description')}</p>
        </Reveal>

        <div className="mx-auto mt-12 grid max-w-[1146px] gap-6 lg:mt-14 lg:grid-cols-2">
          {CARDS.map(({ id, image, imageClass }, index) => {
            const img = shot(image, i18n.language);
            return (
              <Reveal key={id} delay={index * 90} className="lp-card flex flex-col">
                <div className="relative h-[240px] overflow-hidden bg-sand-200 sm:h-[300px] lg:h-[320px]">
                  <img
                    src={img.src}
                    width={img.width}
                    height={img.height}
                    alt={t(`landing.collaboration.${id}.alt`)}
                    loading="lazy"
                    decoding="async"
                    className={`lp-shot absolute ${imageClass}`}
                  />
                </div>
                <div className="px-7 py-8 sm:px-10 lg:py-9">
                  <h3 className="lp-h3">{t(`landing.collaboration.${id}.title`)}</h3>
                  <p className="lp-body mt-3">{t(`landing.collaboration.${id}.description`)}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <ul className="mx-auto mt-6 grid max-w-[1146px] gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {EXTRAS.map(({ id, icon: Icon }, index) => (
            <Reveal as="li" key={id} delay={index * 60} className="lp-card flex gap-4 p-5 sm:block sm:p-6">
              <Icon className="h-6 w-6 shrink-0 text-ink" aria-hidden="true" />
              <p className="text-[17px] leading-[1.4] text-black/60 sm:mt-8">
                <span className="font-medium text-ink">{t(`landing.collaboration.extras.${id}.title`)}</span>{' '}
                {t(`landing.collaboration.extras.${id}.description`)}
              </p>
            </Reveal>
          ))}
        </ul>
      </Container>
    </section>
  );
}
